import { useDispatch, useSelector } from 'react-redux'
import { useLazyGetProjectLeaderboardQuery } from '../../modules/missionControl/api'
import { setLeaderboard } from '../../modules/missionControl/slice'
import { selectLeaderboard } from '../../modules/missionControl/selectors'
import { useCallback, useEffect } from 'react'

function useLeaderboard(projectId?: number) {
  const dispatch = useDispatch()
  const leaderboard = useSelector(selectLeaderboard)
  const [fetchLeaderboard, { isLoading, isFetching }] =
    useLazyGetProjectLeaderboardQuery()

  const handleFetchLeaderboard = useCallback(
    async ({
      projectId,
      limit,
      offset,
    }: {
      projectId: number
      limit: number
      offset: number
    }) => {
      try {
        const { leaderboard } = await fetchLeaderboard({
          projectId,
          limit,
          offset,
        }).unwrap()
        dispatch(setLeaderboard(leaderboard))
      } catch (error) {
        console.error('Error fetching leaderboard', error)
      }
    },
    [dispatch, fetchLeaderboard],
  )

  const hasLeaderboardInStore = !!leaderboard
  useEffect(() => {
    if (!hasLeaderboardInStore && projectId)
      handleFetchLeaderboard({ projectId, limit: 10, offset: 0 })
  }, [handleFetchLeaderboard, hasLeaderboardInStore, projectId])

  return {
    leaderboard,
    loading: isLoading || isFetching,
    handleFetchLeaderboard,
  }
}

export default useLeaderboard
